import { Show } from "solid-js";
import { useWidgetApp } from "~/provider";
import { ArticleDialog } from "../ArticleDialog";
import { MoreInfo } from "../MoreInfo";
import { Root } from "./desktop";
import { MobileRoot } from "./mobile";

export function DocumentRoot() {
	const { screen } = useWidgetApp();

	return (
		<>
			<MoreInfo />
			<ArticleDialog />
			<Show
				when={screen() === "desktop"}
				fallback={<MobileRoot />}
			>
				<Root />
			</Show>
		</>
	);
}
